var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v(" "+_vm._s(_vm.start)+" ~ "+_vm._s(_vm.end)+" "),(_vm.showRemain)?_c('span',[_vm._v("（剩 "+_vm._s(_vm.remain(_vm.data.EndTime))+" 天）")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }